import type { TemplateIcon } from "@/content/templates"

/** The reference stroke weight, tuned against a 16-unit viewBox. */
const BASE_STROKE = 1.4
const BASE_VIEWBOX_SIZE = 16

/** Renders a `TemplateIcon`'s shapes into one `<svg>` — see `IconShape` in
 *  `content/templates` for why the icon is a shape list rather than a path. */
export default function Glyph({ icon }: { icon: TemplateIcon }) {
  const viewBoxSize = Number(icon.viewBox.split(" ")[2]) || BASE_VIEWBOX_SIZE
  const strokeWidth = (BASE_STROKE * viewBoxSize) / BASE_VIEWBOX_SIZE

  return (
    <svg
      width="20"
      height="20"
      viewBox={icon.viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {icon.shapes.map((shape, index) => {
        switch (shape.kind) {
          case "path":
            return <path key={index} d={shape.d} />
          case "circle":
            return <circle key={index} cx={shape.cx} cy={shape.cy} r={shape.r} />
          case "rect":
            return (
              <rect
                key={index}
                x={shape.x}
                y={shape.y}
                width={shape.width}
                height={shape.height}
                rx={shape.rx}
              />
            )
        }
      })}
    </svg>
  )
}
